export var GuidedWalkthroughSubject;
(function (GuidedWalkthroughSubject) {
    GuidedWalkthroughSubject["HeaderBadge"] = "guided-walkthrough-header-badge";
    GuidedWalkthroughSubject["UnseenTasksBadge"] = "guided-walkthrough-unseen-task-badge";
    GuidedWalkthroughSubject["Drawer"] = "guided-walkthrough-drawer";
    GuidedWalkthroughSubject["DrawerContent"] = "guided-walkthrough-drawer-content";
    GuidedWalkthroughSubject["DrawerCloseButton"] = "guided-walkthrough-drawer-close-button";
    GuidedWalkthroughSubject["PhasesList"] = "guided-walkthrough-phases-list";
    GuidedWalkthroughSubject["Task"] = "guided-walkthrough-task";
    GuidedWalkthroughSubject["TaskAction"] = "guided-walkthrough-task-action";
    GuidedWalkthroughSubject["TodoTaskBadge"] = "guided-walkthrough-todo-task-badge";
    GuidedWalkthroughSubject["LockedTaskBadge"] = "guided-walkthrough-locked-task-badge";
    GuidedWalkthroughSubject["DoneTaskBadge"] = "guided-walkthrough-done-task-badge";
    GuidedWalkthroughSubject["ProgressLabel"] = "guided-walkthrough-progress-label";
})(GuidedWalkthroughSubject || (GuidedWalkthroughSubject = {}));
//# sourceMappingURL=guided-walkthrough.enum.js.map